export const NEW_CONFERENCE = 'events/NEW_CONFERENCE';

/**
 * @return {{type: string}}
 */
export const newConference = () => ({ type: NEW_CONFERENCE });
